import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { RoutedStepsOrchestrator } from '@savgroup-front-common/core/molecules/RoutedStepsOrchestrator/RoutedStepsOrchestrator';
import { OnSubmit } from '@savgroup-front-common/core/molecules/RoutedStepsOrchestrator/RoutedStepsOrchestrator.types';

import { PROFESSIONAL_STEP_CONFIG } from '../../../app/NewLayout/ProfessionalRoutes.config';
import { buildProfessionalRoute } from '../../../app/NewLayout/ProfessionalRoutes.helpers';

import { STEPS_CONFIG } from './IrshPages.config';
import { IrshStepValues } from './IrshPages.types';

export const IrshPages: FC = () => {
  const navigate = useNavigate();

  const handleOnSubmit: OnSubmit<IrshStepValues> = useCallback(
    ({ values }) => {
      if (!values.fileId) {
        throw new Error('File id is required');
      }

      const fileFollowupUrl = buildProfessionalRoute({
        route: PROFESSIONAL_STEP_CONFIG.PROFESSIONAL_FILE_FOLLOWUPS_PAGE,
        payload: {
          fileId: values.fileId,
        },
      });

      navigate(fileFollowupUrl);
    },
    [navigate],
  );

  return (
    <RoutedStepsOrchestrator
      config={STEPS_CONFIG}
      onSubmit={handleOnSubmit}
      baseRoute={'/professional'}
    />
  );
};
